import React from "react";
import ListCompanyHierarchy from "../../../containers/Settings/CompanyHierarchy/index";
const SettingCompanyHierarchy = () => {
  return <ListCompanyHierarchy />;
};
export default SettingCompanyHierarchy;
